import { render, staticRenderFns } from "./CheckForDupsBlock.vue?vue&type=template&id=ad55391c&scoped=true"
import script from "./CheckForDupsBlock.vue?vue&type=script&lang=js"
export * from "./CheckForDupsBlock.vue?vue&type=script&lang=js"
import style0 from "./CheckForDupsBlock.vue?vue&type=style&index=0&id=ad55391c&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad55391c",
  null
  
)

export default component.exports